import {onUnmounted, Ref, watch} from "vue";
import {SurveyAnswerInstance} from "@/core/interfaces/survey/Survey";

interface SummarizeEventData {
    summarizable_type: 'survey-answer';
    summarizable_id: number;
    id: number;
    summary: string;
}

/**
 * Composable for listening to survey answer summarization events via WebSocket and updating the survey answer instance
 * with the received summary.
 */
const useSurveySummaryListener = (instance: Ref<SurveyAnswerInstance | undefined>) => {
    let removeSocketListener: (() => void) | null = null;

    watch(() => instance.value?.id, (id) => {
        if(id) {
            setupSocketListener(id);
        }
    }, {immediate: true});

    /**
     * Setup the socket listener for survey answer summarization events.
     */
    const setupSocketListener = (instanceId: number) => {
        if (removeSocketListener) {
            return;
        }

        removeSocketListener = window.ipcRenderer.socketListenEvent(
            'survey-answer-instance.summarized',
            (event, {data}: { data: SummarizeEventData }) => {
                if (data.summarizable_id === instanceId) {
                    if(instance.value) {
                        instance.value.ai_summary = {summary: data.summary};
                    }
                }
            }
        );
    };

    /**
     * Clean up the socket listener when it's no longer needed.
     */
    const cleanupSocketListener = () => {
        if (removeSocketListener) {
            removeSocketListener();
            removeSocketListener = null;
        }
    };

    onUnmounted(() => {
        cleanupSocketListener();
    });
};

export default useSurveySummaryListener;
